<template>
    <v-row>
        <v-col cols="12">
            <v-btn color="abadPrimary" dark>Subir fotografía</v-btn>
        </v-col>

        <v-col cols="12">
            <v-btn color="abadPrimary" dark>Subir imagen 360º</v-btn>
        </v-col>

        <v-col cols="12">
            <v-text-field label="Link de youtube"></v-text-field>
        </v-col>

        <v-col cols="12">
            <v-textarea label="Descripción"></v-textarea>
        </v-col>

        <v-col cols="12">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="abadPrimary" dark @click="submit">Continuar</v-btn>
            </v-card-actions>
        </v-col>
    </v-row>
</template>

<script>
export default {
  methods: {
    submit () {
      this.$emit('updateStateForm', true)
    }
  }
}
</script>
